import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { dealjacketActions, pagetypeActions } from "../../actions";
import { PageTypeDropdown } from "../pagetypes/PageTypeDropdown";
import ReactTooltip from "react-tooltip";
import { DownloadPage } from 'components/search/DownloadPage';

import { SERVER_URL } from "../../constants/constants.js";

import { Mixpanel } from "../../helpers";

function SearchResultsCarousel(props) {
  const { images, currentImage, authentication, org, pagetypes, createPagetype, searchRequest, deal_jacket_name } = props;
  const currentPage = images[currentImage];
  const current_token = authentication.jwt;
  const org_id = org?.current_org_id;
  const current_org = org.list?.filter(
    (o) => o.org_id == org_id
  )[0];
  const limit_pipeline = current_org?.limit_pipeline;
  const user_id = authentication?.user?.user_id;
  const ungrouped_id = pagetypes.ungrouped_id;
  const current_page = currentPage;
  const req = searchRequest;

  const jwt = authentication.jwt;

  const iconDownloadPdf = require("../../images/download-pdf.svg");

  const textInput = useRef(null);
  const textInputMessage = "enter page type here";

  const [isZoomed, setIsZoomed] = useState(false);
  const [newTypeName, setNewTypeName] = useState('');

  const updatePageType = (type) => {
    current_page.page_type_id = type;
  }

  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
    console.log(isZoomed);
  };

  const handleNewTypeChange = (e) => {
    const { value } = e.target;
    setNewTypeName(value);
  };

  const addType = () => {
    let pagetype = {};
    pagetype.page_type_name = newTypeName;
    pagetype.page_type_index = 0;
    pagetype.parent_page_type_id = ungrouped_id;
    pagetype.org_id = org_id;
    createPagetype(pagetype);
    textInput.current.value = "";
  };

  const getKey = () => {
    return Number(currentPage?.page_type_id * 10 + currentPage?.page_id);
  };

  const constructPdfUrl = (item) => {
    return (
      SERVER_URL +
      "/org/" +
      org.current_org_id +
      "/dealjacket/" +
      item.deal_jacket_id +
      "/download" +
      "?token=" +
      current_token
    );
  };

  const printableAreaRef = useRef(null);

  const logDownloadClick = (deal_jacket_id) => {
    console.log('logging download click')
    const custom_properties = {
      'tt_user_id': user_id,
      'tt_org_id': org_id,
      'tt_deal_jacket_id': deal_jacket_id
    };
    Mixpanel.track('DownloadPdfFromCarousel', custom_properties);
  }

  return (
    <>
      {currentPage && isZoomed && (
        <div class="zoomedPageTypeImage" onClick={toggleZoom}>
          <img src={currentPage?.image_path + '?t=' + jwt} onClick={toggleZoom} alt="current page" loading="lazy" />
        </div>
      )}
      {currentPage && (
        <div className="carouselContent">
          <div className="carouselContentBuffer">
            <div ref={printableAreaRef} className="carouselImage">
              <img
                className="carouselImageContent"
                src={currentPage.image_path + '?t=' + jwt}
                height="100%"
                loading="lazy"
                alt="current page"
                onClick={toggleZoom}
              />
            </div>
            <div className="carouselForm">
              <table className="carouselFormTable">
                <tbody>
                  <tr>
                    <td colSpan="2" className="formInfo">
                      {currentPage?.deal_jacket_name.length > 70
                        ? currentPage?.deal_jacket_name.substring(0, 70) + "..."
                        : currentPage?.deal_jacket_name}
                    </td>
                  </tr>
                  {!limit_pipeline &&
                    <>
                      <tr>
                        <td className="formLabel">Group:&nbsp;</td>
                        <td className="formInfo">{currentPage?.page_group_name}</td>
                      </tr>
                      <tr>
                        <td className="formLabel">Page Type:&nbsp;</td>
                        <td className="formInfo">{currentPage?.page_type_name}</td>
                      </tr>
                    </>
                  }

                  {!limit_pipeline && authentication?.user?.org_id === 1 && (
                    <>
                      <tr>
                        <td colSpan="2"><hr /></td>
                      </tr>
                      <tr>
                        <td className="formLabel">select page type:</td>
                        <td className="formInfo"><PageTypeDropdown key={getKey} selectedType={current_page?.page_type_id} page={current_page} afterHandler={updatePageType} /></td>
                      </tr>

                      <tr>
                        <td colSpan="2">&nbsp;</td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                        <td>--or--</td>
                      </tr>
                      <tr>
                        <td colSpan="2" align="center">add a new ungrouped page type:</td>
                      </tr>
                      <tr>
                        <td className="formLabel">new page type:</td>
                        <td className="formInfo"><input ref={textInput} name="newType" id="newType" type="text" size="30" onChange={handleNewTypeChange} placeholder={textInputMessage} /></td>
                      </tr>
                      <tr>
                        <td align="center" colSpan="2">
                          <span id="addType" className="formButton" name="addType" onClick={addType}>Add Type</span>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2"><hr /></td>
                      </tr>
                    </>
                  )}
                  <tr>
                    <td className="formLabel">Tag Tech File Id:&nbsp;</td>
                    <td className="formInfo">{currentPage?.deal_jacket_id}</td>
                  </tr>
                  <tr>
                    <td className="formLabel">Tag Tech Page Id:&nbsp;</td>
                    <td className="formInfo">{currentPage?.page_id}</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>
                      <div className="carouselActions">
                        {!limit_pipeline &&
                          <DownloadPage key={currentPage.page_id} currentPage={currentPage} />
                        }

                        <span
                          data-tip
                          data-for={"Download Deal Jacket"}
                          className="carouselAction"
                        >
                          <a href={constructPdfUrl(currentPage)} onClick={(event) => logDownloadClick(currentPage?.deal_jacket_id)}>
                            <img
                              className="carouselActionImage"
                              src={iconDownloadPdf}
                              alt="Download File"
                            />
                          </a>
                        </span>
                        <ReactTooltip
                          id={"Download File"}
                          place="bottom"
                          effect="solid"
                          data-type="info"
                          delayShow={200}
                        >
                          Download File
                        </ReactTooltip>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>
                      {!limit_pipeline &&
                        <div>
                          Is the page type incorrect? Please help us to improve your archive.<br />
                          Click here to report the issue:<br />
                          <a href="https://airtable.com/shrSimTsQSE3VhhEc" target="_blank" rel="noopener noreferrer">Report Improperly Classified Page</a>
                        </div>
                      }

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function mapStateToProps(state) {
  const { authentication, pagetypes, org, page } = state;
  return {
    authentication,
    pagetypes,
    org,
    page,
  };
}

const actionCreators = {
  getPageTypeList: pagetypeActions.getList,
  createPagetype: pagetypeActions.createPagetype,
};

const connectedSearchResultsCarousel = connect(
  mapStateToProps,
  actionCreators
)(SearchResultsCarousel);
export { connectedSearchResultsCarousel as SearchResultsCarousel };
